import {
  DOCUMENT_PRIVACY_POLICY,
  PFLEGEPORTAL_WEBSITE,
  WESER_EMS_IMPRESSUM_URL,
} from "core/consts";
import { RecareNameLogo } from "ds_legacy/components/RecareLogo";
import { TEXT_DARK_HINT, WHITE } from "ds_legacy/materials/colors";
import {
  HorizontalLayout,
  ResponsiveLayout,
  VerticalLayout,
} from "ds_legacy/materials/layouts";
import {
  SMALL,
  Z_INDEX_APP_BAR,
  dp,
  margin,
  sizing,
} from "ds_legacy/materials/metrics";
import {
  Caption,
  FONT_SIZE_10,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_REGULAR,
  LINE_HEIGHT_16,
  Link,
} from "ds_legacy/materials/typography";
import Image from "dsl/atoms/Image";
import { useLegalDocuments } from "dsl/atoms/LegalDocuments";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { useHover } from "dsl/hooks";
import styled from "styled-components";
import { useTranslations } from "translations";

export const FOOTER_HEIGHT = 88;

const FooterWrapper = styled(HorizontalLayout)`
  display: flex;
  width: 100vw;
  height: ${dp(FOOTER_HEIGHT)};
  align-items: center;
  justify-content: center;
  background: ${WHITE};
  z-index: ${Z_INDEX_APP_BAR - 1};
`;

const StyledLink = styled(Link)`
  font-size: ${FONT_SIZE_10};
  font-weight: ${FONT_WEIGHT_REGULAR};
  color: ${TEXT_DARK_HINT};
  line-height: ${LINE_HEIGHT_16};
`;

const StyledCaption = styled(Caption)`
  font-size: ${FONT_SIZE_10};
  font-weight: ${FONT_WEIGHT_BOLD};
  color: ${TEXT_DARK_HINT};
  margin: ${margin(0)};
  line-height: ${LINE_HEIGHT_16};
`;

function LogoSection() {
  const { isMobile } = useMedia();
  const translations = useTranslations();
  const { isHover, onHoverProps } = useHover();
  const logoStyle = {
    cursor: isHover ? "pointer" : "auto",
    filter: "grayscale(1) invert(0.6)",
    height: isMobile ? sizing(3) : sizing(7),
    width: isMobile ? sizing(7) : sizing(12),
  };
  return (
    <ResponsiveLayout>
      <Image
        alt="pflegeportal-logo"
        linkProps={{ target: "_blank", to: PFLEGEPORTAL_WEBSITE }}
        path="pflegeportal-logo.png"
        style={{
          ...logoStyle,
          margin: isMobile ? margin(1) : margin(1, 1, 1, 4),
        }}
        {...onHoverProps}
      />
      <RecareNameLogo
        linkProps={{ target: "_blank", to: translations.general.websiteUrl }}
        size={SMALL}
        style={{ ...logoStyle, margin: "auto 0" }}
        {...onHoverProps}
      />
    </ResponsiveLayout>
  );
}

function AboutSection() {
  const translations = useTranslations();
  const { openDocumentUrl } = useLegalDocuments();
  return (
    <VerticalLayout margin={margin(0, 1.5)}>
      <StyledCaption>{translations.bToC.footer.aboutRecare}</StyledCaption>
      <StyledLink
        onClick={() => window.open(translations.general.websiteUrl, "_blank")}
      >
        {translations.bToC.footer.website}
      </StyledLink>
      <StyledLink
        onClick={() => window.open(WESER_EMS_IMPRESSUM_URL, "_blank")}
      >
        {translations.bToC.footer.imprint}
      </StyledLink>
      <StyledLink onClick={() => openDocumentUrl(DOCUMENT_PRIVACY_POLICY)}>
        {translations.bToC.footer.privacyPolicy}
      </StyledLink>
    </VerticalLayout>
  );
}

function ContactInfoSection() {
  const translations = useTranslations();

  return (
    <VerticalLayout margin={margin(0, 1.5)}>
      <StyledCaption>{translations.bToC.footer.support}</StyledCaption>
      <StyledLink href="tel:03056796057">030 56796057</StyledLink>
      <StyledLink href="mailto:info@recaresolutions.com" target="_blank">
        info@recaresolutions.com
      </StyledLink>
    </VerticalLayout>
  );
}
export default function Footer() {
  return (
    <FooterWrapper>
      <HorizontalLayout aligned justify="space-between" width="95%">
        <LogoSection />
        <HorizontalLayout>
          <AboutSection />
          <ContactInfoSection />
        </HorizontalLayout>
      </HorizontalLayout>
    </FooterWrapper>
  );
}
